const initSection = (section) => {
	section.querySelectorAll(".key-features__toggle").forEach((button) => {
		button.addEventListener("click", () => {
			const panel = button.closest(".key-features__panel");

			if (!panel) {
				return;
			}

			const isExpanded = panel.classList.toggle("is-expanded");
			const expandedPanel = panel.querySelector(".key-features__panel-expanded");

			button.setAttribute("aria-expanded", isExpanded ? "true" : "false");

			if (expandedPanel) {
				expandedPanel.hidden = !isExpanded;
			}
		});
	});
};

const init = () => {
	document.querySelectorAll(".key-features").forEach(initSection);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
